import React from "react";
import { Outlet } from "react-router-dom";

import Container from "@mui/material/Container";

export default function () {
    return (
        <Container maxWidth={"xl"} className={"atsGlobalContainer"}>
            <Outlet />
        </Container>
    );
}
